var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.rosterService === _vm.ROSTER_SERVICE_CLEVER
      ? _c("div", { staticClass: "form-group" }, [
          _c("p", [
            _vm._v("\n        Bearer Token: "),
            _vm.showSecret
              ? _c("code", [_vm._v(_vm._s(_vm.cleverConfig.bearerToken))])
              : !_vm.showSecret && _vm.cleverConfig.bearerToken
              ? _c("code", [_vm._v("••••••••")])
              : _c("span", [_c("strong", [_vm._v("Not set")])]),
            _vm._v(" "),
            _vm.cleverConfig.bearerToken
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-link btn-sm",
                    attrs: {
                      type: "button",
                      "aria-label": _vm.showSecret
                        ? "Hide bearer token"
                        : "Show bearer token",
                      "aria-pressed": _vm.showSecret
                    },
                    on: { click: _vm.toggleSecret }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.showSecret ? "(hide)" : "(show)") +
                        "\n        "
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", [
            _c("p", [
              _vm._v("District Admins: "),
              _c("strong", [
                _vm._v(_vm._s(_vm.cleverConfig.districtAdmins || "Not set"))
              ])
            ]),
            _vm._v(" "),
            _vm.cleverConfig.districtAdminEmails &&
            _vm.cleverConfig.districtAdminEmails.length > 0
              ? _c(
                  "ul",
                  _vm._l(_vm.cleverConfig.districtAdminEmails, function(
                    email,
                    index
                  ) {
                    return _c("li", { key: index }, [
                      _vm._v("\n            " + _vm._s(email) + "\n          ")
                    ])
                  }),
                  0
                )
              : _vm._e()
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.rosterService === _vm.ROSTER_SERVICE_ONEROSTER
      ? _c("div", { staticClass: "form-group" }, [
          _c("p", [
            _vm._v("Client ID: "),
            _c("strong", [
              _vm._v(_vm._s(_vm.oneRosterConfig.clientId || "Not set"))
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n        Client Secret: "),
            _vm.showSecret
              ? _c("code", [_vm._v(_vm._s(_vm.oneRosterConfig.clientSecret))])
              : !_vm.showSecret && _vm.oneRosterConfig.clientSecret
              ? _c("code", [_vm._v("••••••••")])
              : _c("span", [_c("strong", [_vm._v("Not set")])]),
            _vm._v(" "),
            _vm.oneRosterConfig.clientSecret
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-link btn-sm",
                    attrs: {
                      type: "button",
                      "aria-label": _vm.showSecret
                        ? "Hide client secret"
                        : "Show client secret",
                      "aria-pressed": _vm.showSecret
                    },
                    on: { click: _vm.toggleSecret }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.showSecret ? "(hide)" : "(show)") +
                        "\n        "
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Endpoint URL: "),
            _c("strong", [
              _vm._v(_vm._s(_vm.oneRosterConfig.endpoint || "Not set"))
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("API Version: "),
            _c("strong", [
              _vm._v(_vm._s(_vm.oneRosterConfig.apiVersion || "Not set"))
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Unique ID Field: "),
            _c("strong", [
              _vm._v(_vm._s(_vm.oneRosterConfig.uniqueIdField || "Not set"))
            ])
          ]),
          _vm._v(" "),
          _vm.oneRosterConfig.titleField
            ? _c("p", [
                _vm._v("Title Field: "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.oneRosterConfig.titleField || "Not set"))
                ])
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.rosterService === _vm.ROSTER_SERVICE_S3CSV
      ? _c("div", { staticClass: "form-group" }, [
          _c("p", [
            _vm._v("S3 CSV Input Directory: "),
            _c("code", [
              _vm._v(_vm._s(_vm.s3CsvConfig.inputDirectory || "Not set"))
            ])
          ]),
          _vm._v(" "),
          _vm.s3CsvConfig.filenamePrefix
            ? _c("p", [
                _vm._v("File Name Prefix: "),
                _c("code", [_vm._v(_vm._s(_vm.s3CsvConfig.filenamePrefix))])
              ])
            : _vm._e(),
          _vm._v(" "),
          Object.values(_vm.s3CsvConfig.fieldMappings).some(value => value)
            ? _c("div", [
                _c("p", [_vm._v("Custom Field Mappings:")]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v("Name Field: "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.s3CsvConfig.fieldMappings.name_field))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v("Email Field: "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.s3CsvConfig.fieldMappings.email_field))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v("Title Field: "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.s3CsvConfig.fieldMappings.title_field))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v("School Field: "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.s3CsvConfig.fieldMappings.school_field))
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.s3CsvConfig.fieldMappings.external_id_field
                    ? _c("li", [
                        _vm._v("External ID Field: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.s3CsvConfig.fieldMappings.external_id_field
                            )
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "latest-file-info" }, [
            _c("p", { staticClass: "control-label" }, [
              _vm._v("Latest File Information:")
            ]),
            _vm._v(" "),
            _vm.loadingFileData
              ? _c("div", { staticClass: "text-muted" }, [
                  _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                  _vm._v(" Loading file information...\n        ")
                ])
              : _vm.fileDataError
              ? _c("div", { staticClass: "text-danger" }, [
                  _c("i", { staticClass: "fa fa-exclamation-triangle" }),
                  _vm._v(" " + _vm._s(_vm.fileDataError) + "\n        ")
                ])
              : _vm.latestFileData
              ? _c("div", [
                  _c(
                    "p",
                    [
                      _vm._v("File Name: "),
                      _c("code", [
                        _vm._v(_vm._s(_vm.latestFileData.file_name))
                      ]),
                      _vm.latestFileData.download_url
                        ? _c("file-download-button", {
                            attrs: {
                              url: _vm.latestFileData.download_url,
                              "file-name": _vm.latestFileData.file_name
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "last-modified-row" },
                    [
                      _c("span", [
                        _vm._v("Last Modified: "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.formattedLastModified))
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.isStaleFile ? _c("stale-file-icon") : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("File Size: "),
                    _c("strong", [_vm._v(_vm._s(_vm.formattedFileSize))])
                  ])
                ])
              : _c("div", { staticClass: "text-muted" }, [
                  _vm._v("\n          No files found\n        ")
                ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }